import React from "react";
import styles from "./synced-org-chart.module.css";
import { OrgChartMappingSkeleton } from "./org-chart-mapping-skeleton";

const ShimmerGradient = ({ id }: { id: string }) => (
  <defs>
    <linearGradient id={id} x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%" stopColor="#EBEDF3" stopOpacity="1" />
      <stop offset="50%" stopColor="#f5f6f8" stopOpacity="1" />
      <stop offset="100%" stopColor="#EBEDF3" stopOpacity="1" />
      <animate attributeName="x1" from="-100%" to="100%" dur="2.2s" repeatCount="indefinite" />
      <animate attributeName="x2" from="0%" to="200%" dur="2.2s" repeatCount="indefinite" />
    </linearGradient>
  </defs>
);

export const OrgChartSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.selectorsRow}>
          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="28" fill="none" viewBox="0 0 156 28">
            <ShimmerGradient id="shimmer-selector-1" />
            <rect width="156" height="28" fill="url(#shimmer-selector-1)" rx="6"></rect>
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="156" height="28" fill="none" viewBox="0 0 156 28">
            <ShimmerGradient id="shimmer-selector-2" />
            <rect width="156" height="28" fill="url(#shimmer-selector-2)" rx="6"></rect>
          </svg>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="180" height="16" fill="none" viewBox="0 0 180 16">
          <ShimmerGradient id="shimmer-title" />
          <rect width="180" height="16" fill="url(#shimmer-title)" rx="6"></rect>
        </svg>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="12"
          fill="none"
          viewBox="0 0 240 12"
          style={{ marginTop: "8px" }}
        >
          <ShimmerGradient id="shimmer-subtitle" />
          <rect width="240" height="12" fill="url(#shimmer-subtitle)" rx="6"></rect>
        </svg>
      </div>

      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="1" fill="none" viewBox="0 0 100 1">
        <line x1="0" y1="0.5" x2="100%" y2="0.5" stroke="#E5E8EA" />
      </svg>

      <OrgChartMappingSkeleton />
    </div>
  );
};
